import { useEffect } from 'react';

import { doRequest } from '@r1-frontend/do-request';
import { requestByConnection, ResponseDto } from '@r1-frontend/api-domru/api-request/v1/user/request-by-connection';

import { EProductsId } from '@r1-frontend/shared/types/EProductsId';

declare global {
    interface Window {
        sendRequestByConnection?: (payload: IPayload) => Promise<void>,
    }
}

interface IPayload {
    phone: string,
    email?: string,
    source?: string,
}

const useSendRequestByConnection = (csrf: string | null) => {
    useEffect(() => {
        if (csrf) {
            window.sendRequestByConnection = async({ phone, email, source }: IPayload) => {
                await doRequest.apiRequest<ResponseDto>(requestByConnection({
                    fio: 'Потенциальный клиент',
                    product_id: [EProductsId.internet],
                    app_deal_method: source,
                    phone,
                    email,
                    csrf,
                }));
                window.location.reload();
            };
        }
        return () => {
            window.sendRequestByConnection = undefined;
        };
    }, [csrf]);
};

export default useSendRequestByConnection;


